import React from 'react';
import { CgFacebook } from "react-icons/cg";
import { AiFillInstagram } from "react-icons/ai";
import { BsYoutube } from "react-icons/bs";
import { NavLink } from 'react-router-dom';

const path = "/neethusapp";

const Footer = () => {

    return (
        <>
            <footer style={{ paddingTop: '20px' }}>
                <div className="container">
                    <div className="footerMain">
                        <div className="footerSocialLinks">
                            <a href="https://www.facebook.com/neethusacademyofficial/" target='_blank'><CgFacebook /></a>
                            <a href="https://www.instagram.com/neethus_academy_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target='_blank'><AiFillInstagram /></a>
                            <a href="https://www.youtube.com/@neethusacademyofficial?si=TJWyxlNnAC0hQ5Zh" target='_blank'><BsYoutube /></a>
                        </div>
                        <div className="footerContact">
                            <a href="mailto:hr@neethusacademy.com">hr@neethusacademy.com</a>
                            <a href="tel:+919747944374" 
                                onClick={(e) => {
                                    if (!window.location.href.includes('tel:')) {
                                        e.preventDefault();
                                        window.open('tel:+919633133374', '_self');
                                    }
                                }}>
                                    +91 9747 944 374
                            </a>
                            <ul>
                                <li>
                                    <NavLink to="https://neethusacademy.com/terms-conditions.html" target='_blank'>Terms & Conditions</NavLink>
                                </li>
                                <li>
                                    <NavLink to="https://neethusacademy.com/privacy-policy.html" target='_blank'>Privacy Policy</NavLink>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
